import {Button, Dropdown, MenuProps} from "antd";
import useUserContext from "../../hooks/useUserContext";
import useAppContext from "../../hooks/useAppContext";
import {useNavigate} from "react-router-dom";
import {UserOutlined} from "@ant-design/icons";
import "./user-menu.css";

const UserMenu = () => {
    const { user, actions: { getFirstName, logout } } = useUserContext();
    const { actions: { clearData }} = useAppContext();
    const navigate = useNavigate();

    const onLogout = () => {
        logout();
        clearData();
        navigate('/login');
    }

    const items: MenuProps['items'] = [
        {
            key: '1',
            label: (
                <div onClick={() => navigate("/profile")}>
                    Profile
                </div>
            ),
        },
        // {
        //     key: '2',
        //     label: (
        //         <a href="#">
        //             Your Sites
        //         </a>
        //     ),
        // },
        {
            key: '3',
            label: (
                <div onClick={onLogout}>
                    Logout
                </div>
            ),
        },
    ];

    if(!user) return <Button>Login</Button>;

    return <Dropdown menu={{ items }} placement="bottomRight">
        <Button className="outlined user-menu" >
            <span className="user-name">{getFirstName()}</span>
            <UserOutlined className="user-avatar" />
        </Button>
    </Dropdown>
}

export default UserMenu;